// removed by extract-text-webpack-plugin
module.exports = {"base":"FullSchedule_base--qEFMk","heading":"FullSchedule_heading--pZZv8"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/FullSchedule/FullSchedule.scss
// module id = 478
// module chunks = 11 12